export default __webpack_public_path__ + "static/media/CORK-logo.d5dcd8f0.png";